import { RocheUIBackToBranch } from '@repo/roche-ui';
import React, { FC } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { Link } from '../../services/navigation/types';
import { NavigationService } from '../../services/navigation';

type RocheBackToBranchProps = BlokToComponentProps<{
  overline_text: string;
  headline: string;
  link_text: string;
  icon: 'list' | 'arrow-right';
  href: Link;
  slot?: string;
}>;

export const RocheBackToBranch: FC<RocheBackToBranchProps> = ({ blok, slot }) => {
  const link = NavigationService.getParsedNavigationLink(blok.href);

  return (
    <RocheUIBackToBranch
      link={link}
      slot={slot}
      overlineText={blok.overline_text}
      linkText={blok.link_text}
      {...blok}
    />
  );
};
